var exports = {
  "full-height": "x1cb7f6e3--a62089--full-height",
  "container": "x1cb7f6e3--a62089--container",
  "desktop": "x1cb7f6e3--a62089--desktop",
  "content": "x1cb7f6e3--a62089--content",
  "pages": "x1cb7f6e3--a62089--pages",
  "media-stack": "x1cb7f6e3--a62089--media-stack",
  "page": "x1cb7f6e3--a62089--page",
  "media-layer": "x1cb7f6e3--a62089--media-layer",
  "page-active": "x1cb7f6e3--a62089--page-active",
  "media-layer-active": "x1cb7f6e3--a62089--media-layer-active",
  "pages-animated": "x1cb7f6e3--a62089--pages-animated",
  "image": "x1cb7f6e3--a62089--image",
  "image-placeholder": "x1cb7f6e3--a62089--image-placeholder",
  "page-title": "x1cb7f6e3--a62089--page-title",
  "description": "x1cb7f6e3--a62089--description",
  "list": "x1cb7f6e3--a62089--list",
  "footer": "x1cb7f6e3--a62089--footer",
  "footer-desktop": "x1cb7f6e3--a62089--footer-desktop",
  "footer-side": "x1cb7f6e3--a62089--footer-side",
  "footer-side-right": "x1cb7f6e3--a62089--footer-side-right",
};

module.exports = exports;
